(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[368],{

/***/ 30760:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutors/[slug]/reviews",
      function () {
        return __webpack_require__(93326);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ TutorsProfileReviews; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78182);
/* harmony import */ var _components_tutorProfile_SummaryPanel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(561);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51436);
/* harmony import */ var _components_tutorProfile_ReviewsList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56746);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);











var __N_SSG = true;
function TutorsProfileReviews(param) {
    let { tutorProfile , reviews  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                    children: [
                        "Reviews | ",
                        tutorProfile.firstNameAndLastInitial,
                        " | Tutorspot"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "pt-3 mb-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "mb-3",
                        children: [
                            "Client Reviews for ",
                            tutorProfile.firstNameAndLastInitial
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                xs: 12,
                                md: 8,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mb-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/tutors/".concat(tutorProfile.slug),
                                            passHref: true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faArrowLeft */ .acZ,
                                                    className: "me-1"
                                                }),
                                                "Back to Profile"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Body */ .Z.Body, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tutorProfile_ReviewsList__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                tutorProfile: tutorProfile,
                                                reviews: reviews,
                                                showSeeAll: false
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                xs: 12,
                                md: 4,
                                className: "d-none d-md-block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Body */ .Z.Body, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tutorProfile_SummaryPanel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            tutorProfile: tutorProfile
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 22859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/helpers.js

class BsPrefixComponent extends react.Component {} // Need to use this instead of typeof Component to get proper type checking.

function getOverlayDirection(placement, isRTL) {
  let bsDirection = placement;

  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }

  return bsDirection;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js






const defaultProps = {
  placement: 'right'
};
const Tooltip = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement,
  className,
  style,
  children,
  arrowProps,
  popper: _,
  show: _2,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'tooltip');
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    style: style,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classnames_default()(className, bsPrefix, `bs-tooltip-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "tooltip-arrow",
      ...arrowProps
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: `${bsPrefix}-inner`,
      children: children
    })]
  });
});
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';
/* harmony default export */ var esm_Tooltip = (Tooltip);

/***/ }),

/***/ 13773:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var e=__webpack_require__(85893),o=__webpack_require__(67294);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=t(o),n=function(){return(n=Object.assign||function(e){for(var o,t=1,i=arguments.length;t<i;t++)for(var n in o=arguments[t])Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n]);return e}).apply(this,arguments)};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function r(e,o,t){if(t||2===arguments.length)for(var i,n=0,r=o.length;n<r;n++)!i&&n in o||(i||(i=Array.prototype.slice.call(o,0,n)),i[n]=o[n]);return e.concat(i||o)}function l(o){var t=o.size,i=void 0===t?25:t,r=o.strokeColor,l=void 0===r?"none":r,a=o.storkeWidth,c=void 0===a?0:a,s=o.className,u=void 0===s?"star-svg":s,d=o.style;return e.jsx("svg",n({fill:"currentColor",width:i,height:i,viewBox:"0 0 24 24",className:u,style:n({},d)},{children:e.jsx("path",{fill:"currentColor",stroke:l,strokeMiterlimit:"10",strokeWidth:c,d:"M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z"},void 0)}),void 0)}var a=function(){return"ontouchstart"in window||navigator.maxTouchPoints>0};function c(e,o){switch(o.type){case"PointerMove":return n(n({},e),{hoverValue:o.payload});case"PointerLeave":return{defaultValue:e.defaultValue,hoverValue:null};case"MouseClick":return n(n({},e),{defaultValue:o.payload});default:return e}}exports.i=function(t){var s,u,d=t.onClick,v=t.initialValue,f=void 0===v?0:v,p=t.ratingValue,h=void 0===p?0:p,y=t.iconsCount,m=void 0===y?5:y,g=t.size,k=void 0===g?40:g,x=t.readonly,C=void 0!==x&&x,w=t.fillColor,b=void 0===w?"#ffbc0b":w,j=t.fillColorArray,M=void 0===j?[]:j,L=t.emptyColor,V=void 0===L?"#cccccc":L,N=t.fullIcon,P=void 0===N?null:N,A=t.emptyIcon,R=void 0===A?null:A,S=t.customIcons,z=void 0===S?[]:S,I=t.rtl,O=void 0!==I&&I,T=t.allowHalfIcon,q=void 0!==T&&T,B=t.allowHover,E=void 0===B||B,F=t.transition,H=void 0!==F&&F,W=t.className,_=void 0===W?"react-simple-star-rating":W,D=t.style,X=t.fullClassName,Y=void 0===X?"filled-icons":X,G=t.emptyClassName,J=void 0===G?"empty-icons":G,K=t.fullStyle,Q=t.emptyStyle,U=t.showTooltip,Z=void 0!==U&&U,$=t.tooltipDefaultText,ee=void 0===$?"Your Rate":$,oe=t.tooltipArray,te=void 0===oe?[]:oe,ie=t.tooltipClassName,ne=void 0===ie?"react-simple-star-rating-tooltip":ie,re=t.tooltipStyle,le=o.useReducer(c,{defaultValue:h,hoverValue:null}),ae=le[0],ce=ae.defaultValue,se=ae.hoverValue,ue=le[1];i.default.useEffect((function(){return ue({type:"MouseClick",payload:h})}),[h]);var de=function(e){var o=e.clientX,t=e.currentTarget.children[0].getBoundingClientRect(),i=t.left,n=t.right,r=t.width,l=function(e,o,t){for(var i=100/e,n=t/e,r=100,l=0;l<e;l+=1)if(o<=n*l+n/4){r=0===l&&o<n/2?0:i*l;break}return r}(he,O?n-o:o-i,r);l>0&&se!==l&&ue({type:"PointerMove",payload:l})},ve=function(){se&&(ue({type:"MouseClick",payload:se}),d&&d(se))},fe=o.useMemo((function(){return Math.round(f/m*100)}),[f,m]),pe=o.useMemo((function(){return E&&se&&se||ce&&ce||fe}),[E,se,ce,fe]),he=o.useMemo((function(){return q?2*m:m}),[q,m]),ye=o.useCallback((function(e){var o=1;return e&&(o=q?e/he:e/2/10),Math.round(o-1)}),[q,he]),me=o.useCallback((function(e){return q?e/2/10:ye(e)+1}),[q,ye]),ge=function(e){return te.length>0?te[ye(e)]:me(e)||0};return e.jsxs("span",n({style:{display:"inline-block",direction:"".concat(O?"rtl":"ltr"),touchAction:"none"}},{children:[e.jsxs("span",n({className:_,style:n({position:"relative",display:"inline-block",overflow:"hidden",whiteSpace:"nowrap",cursor:C?"":"pointer",verticalAlign:"middle",userSelect:"none"},D),onPointerMove:C?void 0:de,onPointerEnter:C?void 0:function(e){a()&&de(e)},onPointerLeave:C?void 0:function(){a()&&ve(),ue({type:"PointerLeave"})},onClick:C?void 0:ve,"aria-hidden":"true"},{children:[e.jsx("span",n({className:J,style:n({display:"inline-block",color:V},Q)},{children:r([],Array(m),!0).map((function(t,i){var n;return e.jsx(o.Fragment,{children:(null===(n=z[i])||void 0===n?void 0:n.icon)||R||e.jsx(l,{size:k},i)},i)}))}),void 0),e.jsx("span",n({className:Y,style:n((s={position:"absolute",top:0},s[O?"right":"left"]=0,s.color=E&&se&&M[ye(se)]||ce&&M[ye(ce)]||b,s.overflow="hidden",s.whiteSpace="nowrap",s.display="inline-block",s.transition=H?"width .2s ease, color .2s ease":"",s.width="".concat(pe,"%"),s),K),title:"".concat(se&&me(se)||me(fe)," out of ").concat(m)},{children:r([],Array(m),!0).map((function(t,i){var n;return e.jsx(o.Fragment,{children:(null===(n=z[i])||void 0===n?void 0:n.icon)||P||e.jsx(l,{size:k},void 0)},i)}))}),void 0)]}),void 0),Z&&e.jsx("span",n({className:ne,style:n((u={display:"inline-block",padding:"5px 15px",backgroundColor:"#333",color:"#fff"},u[O?"marginRight":"marginLeft"]=20,u.verticalAlign="middle",u.borderRadius=5,u),re)},{children:se&&ge(se)||ce&&ge(ce)||fe&&ge(fe)||ee}),void 0)]}),void 0)};
//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [766,809,940,774,888,179], function() { return __webpack_exec__(30760); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);